import React, { useEffect, useRef, useState } from 'react'
import "../css/jobDetail.css"
import "../css/jobDetailSl.css"
import "../css/jobDetailSt.css"
import "../css/jobDetailSm.css"
import { DotIcon, JobIcon, LeftArrowIcon, LocationIcon, TimeIcon } from '../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter'
import { IoIosArrowRoundForward } from "react-icons/io";
import RoundButton from '../../../../component-module/component-services/button/round-button/ts/roundButton'
import JobSubmitForm from './jobSubmitted';
import { useNavigate, useParams } from 'react-router-dom';
import jobDetailMock from "./jobDetailMock.json"
import { getJobDetailApi, JobDetailDto, safeJsonParse } from './jobDetail.type'

const JobDetail = () => {
  const navigate = useNavigate()
  const submitFormRef = useRef<HTMLDivElement | null>(null)
  const dataJobDetail = jobDetailMock.jobDetail;
  const sections = dataJobDetail.cta[0];
  const JobSection = sections.submitJobSection;
  const { nameId } = useParams<{ nameId: string }>();
  const [job, setJob] = useState<JobDetailDto | null>(null);
  const [loading, setLoading] = useState(false); //NOSONAR
  const [error, setError] = useState<string | null>(null);  //NOSONAR

  useEffect(() => {
    if (!nameId) return;

    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await getJobDetailApi(nameId);
        if (!alive) return;

        setJob(res.data.data);
      } catch (e: any) {
        if (!alive) return;
        setError(e?.message ?? "Failed to load job detail");
        setJob(null);
      } finally {
        if (!alive) return; //NOSONAR
        setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [nameId]);

  const onClickPosition = () => {
    navigate("/career/position/all")
  }

  const onClickApplyNow = () => {
    submitFormRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  const responsibilities = job?.responsibilities
    ? safeJsonParse<{ responsibleHtml?: string, responsibleDescription?: string }>(job.responsibilities, {})
    : {};

  const requirements = job?.requirements
    ? safeJsonParse<{ requirementsHtml?: string, requirementsDescription?: string }>(job.requirements, {})
    : {};

  const qualification = job?.qualification
    ? safeJsonParse<{ qualificationHtml?: string, qualificationDescription?: string }>(job.qualification, {})
    : {};

  const offer = job?.offer
    ? safeJsonParse<{ offerHtml?: string, offerDescription?: string }>(job.offer, {})
    : {};

  return (
    <main className='scl--jd-co-bo-st'>
      <section className='scl--jcbst-hea-bo-st'>
        <div className='scl--jhbs-pad-cons-bo-stl'>
          <button className='scl--jhbs-but-bo-st' onClick={() => onClickPosition()}>
            <div><LeftArrowIcon /></div>
            <span>Back to all position</span>
          </button>

          <div className='scl--jhbs-her-hea-st'>
            <div className='scl--jhhs-des-sty'>
              <h5>{job?.jobTitle ?? " - "}</h5>
              <div className='scl--jds-tim-loc-st'>
                <div className='scl--jtls-loc-sty'>
                  <LocationIcon />
                  <span title={job?.location}>{job?.location ?? " - "}</span>
                </div>
                <div className='scl--jtls-tim-sty'>
                  <DotIcon />
                  <TimeIcon />
                  <span title={job?.jobType}>{job?.jobType ?? " - "}</span>
                </div>
                <div className='scl--jtls-tim-sty'>
                  <DotIcon />
                  <JobIcon />
                  <span title={job?.jobCode}>{job?.jobCode ?? " - "}</span>
                </div>
              </div>
            </div>

            <div className='scl--jhhs-but-sty'>
              <RoundButton
                text="Apply now"
                icon={<IoIosArrowRoundForward />}
                iconPosition="right"
                onClick={onClickApplyNow}
                className="scl--jd-btn-hea-st"
              />
            </div>
          </div>
        </div>
      </section>

      <section className='scl--jcbs-det-met-st'>
        <div className='scl--jdms-bo-con-wid-st'>
          <div className='scl--jdms-eac-met-da-st'>
            <span className='scl--jemds-ti-tex-st'>Job Summery</span>
            <p className='scl--jemds-par-tex-st'>
              {job?.description ?? " - "}
            </p>
          </div>

          {(responsibilities.responsibleDescription || responsibilities.responsibleHtml) && (
            <div className='scl--jdms-eac-met-da-st'>
              <span className='scl--jemds-ti-tex-st'>Key Responsibilities</span>
              {responsibilities.responsibleDescription &&
                <div className='standalone-description' dangerouslySetInnerHTML={{ __html: responsibilities.responsibleDescription ?? /* istanbul ignore next */ "" }} />
              }
              <div dangerouslySetInnerHTML={{ __html: responsibilities.responsibleHtml ?? /* istanbul ignore next */ "" }} />
            </div>
          )}

          {(requirements.requirementsDescription || requirements.requirementsHtml) && (
            <div className='scl--jdms-eac-met-da-st'>
              <span className='scl--jemds-ti-tex-st'>Required Skill</span>
              {requirements.requirementsDescription &&
                <div className='standalone-description' dangerouslySetInnerHTML={{ __html: requirements.requirementsDescription ?? /* istanbul ignore next */ "" }} />
              }
              <div dangerouslySetInnerHTML={{ __html: requirements.requirementsHtml ?? /* istanbul ignore next */ "" }} />
            </div>
          )}


          {(qualification.qualificationDescription || qualification.qualificationHtml) && (
            <div className='scl--jdms-eac-met-da-st'>
              <span className='scl--jemds-ti-tex-st'>Qualitfication</span>
              {qualification.qualificationDescription && (
                <div
                  className='standalone-description'
                  dangerouslySetInnerHTML={{ __html: qualification.qualificationDescription ?? /* istanbul ignore next */ "" }}
                />
              )}
              <div dangerouslySetInnerHTML={{ __html: qualification.qualificationHtml ?? /* istanbul ignore next */ "" }} />
            </div>
          )}

          {(offer.offerDescription || offer.offerHtml) && (
            <div className='scl--jdms-eac-met-da-st'>
              <span className='scl--jemds-ti-tex-st'>What we offer</span>
              {offer.offerDescription &&
                <div className='standalone-description' dangerouslySetInnerHTML={{ __html: offer.offerDescription ?? /* istanbul ignore next */ "" }} />
              }
              <div dangerouslySetInnerHTML={{ __html: offer.offerHtml ?? /* istanbul ignore next */ "" }} />
            </div>
          )}

        </div>
      </section>

      <div className='scl--jcbs-for--sub-jb-stl' ref={submitFormRef}>
        <JobSubmitForm
          dataJob={JobSection}
          jobUuid={job?.jobId}
          positionName={job?.jobCode}
        />
      </div>
    </main>
  )
}

export default JobDetail